<template>
  <ui-dialog
    v-model="show"
    :hide-overlay="!saving"
    :title="$t(saving ? 'field.new_password' : 'field.password_required')"
    :valid-disabled="pass === ''"
    use-btn-cancel
    @validate="valid"
    @hide="close"
  >
    <v-form
      class="px-2"
      @submit.prevent="valid"
    >
      <v-text-field
        ref="pass"
        v-model="pass"
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        :prepend-inner-icon="IconEnum.password"
        :label="$t('field.index.password')"
        name="password"
        class="needsclick"
        @click:append="displayPass"
      />
      <input
        type="submit"
        style="display: none"
      >
    </v-form>
  </ui-dialog>
</template>

<script>
import { IconEnum } from '@/modules/Enums'
import { MetierLocalStorage } from 'modulelocalstorage'
import { $alert, $closeKeyboard } from '@/modules/Utils'

export default {
  name: 'PasswordDialog',

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: false },
    saving: { type: Boolean, default: false }
  },

  data () {
    return {
      IconEnum,
      dialog: false,
      pass: '',
      showPass: false
    }
  },

  methods: {
    displayPass () {
      if (!this.showPass) {
        this.showPass = true
        setTimeout(() => { this.showPass = false }, 3000)
      }
    },
    valid () {
      if (this.pass === '') {
        this.$nextTick(() => {
          this.$refs.pass.focus()
        })
      } else {
        $closeKeyboard(this.$nextTick)

        let infos = MetierLocalStorage.getUser()

        if (this.saving) {
          if (infos === null) {
            infos = {
              user: null,
              pass: null,
              lockpass: this.pass
            }
          } else {
            infos.lockpass = this.pass
          }
          MetierLocalStorage.setUser(infos)
          this.$emit('valid')
        } else {
          if (this.pass !== infos.lockpass) {
            $alert(this.$i18n.t('error.bad_passwd'))
          } else {
            this.$emit('valid')
          }
        }

        this.pass = ''
      }
    },
    close () {
      this.pass = ''
      this.$emit('cancel')
    }
  }
}
</script>
